import { redirect } from "react-router";
import { createAccountFavoriteProfilesPageURL } from "#lib/urls";

export async function loader() {
  return redirect(String(createAccountFavoriteProfilesPageURL()));
}
